import "core-js/modules/es.number.constructor.js";
import RankList from '~/components/ui/RankList';
import { useGetDisplayOptionsClasses } from '~/composables/useGetDisplayOptionsClasses';
export default defineComponent({
  name: 'ItemRank5Levels',
  components: {
    RankList: RankList
  },
  props: {
    rank: Number,
    title: String,
    underline: Boolean,
    displayOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props) {
    var classes = useGetDisplayOptionsClasses(props.displayOptions);
    return {
      classes: classes
    };
  }
});